<!--
 * @Descripttion: 
 * @version: 
 * @Author: ysoshuaibing
 * @Date: 2022-07-18 10:46:23
 * @LastEditors: DESKTOP-IV14688
 * @LastEditTime: 2023-10-26 16:14:50
-->
<template>
  <svg
    v-bind="$attrs"
    class="svg-icon"
    :class="{ border, btn, bg, bgActive }"
    :style="getStyle"
  >
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  tip: {
    type: String
  },
  prefix: {
    type: String,
    default: 'svg-icon'
  },
  name: {
    type: String,
    required: true
  },
  size: {
    type: [Number, String],
    default: 16
  },
  border: {
    type: Boolean,
    default: false
  },

  color: {
    type: String,
    default: undefined
  },

  padding: {
    type: [Number, String, Array],
    default: 6
  },
  bg: {
    type: Boolean,
    default: false
  },
  bgActive: {
    type: Boolean,
    default: false
  },
  btn: {
    type: Boolean,
    default: false
  },
  width: {
    type: [Number, String]
  },
  height: {
    type: [Number, String]
  },
  rotate: {
    type: [Number, String],
    default: 0
  }
});
const symbolId = computed(() => `#${props.prefix}-${props.name}`);
const getStyle = computed(() => {
  const { size, width, height, rotate } = props;
  const w = width || size;
  const h = height || size;
  const s1 = `${w}`.replace('px', '').concat('px');
  const s2 = `${h}`.replace('px', '').concat('px');
  const padding = Array.isArray(props.padding)
    ? props.padding.map(item => `${item}px`).join(' ')
    : `${props.padding}px`;
  return {
    width: s1,
    height: s2,
    padding,
    color: props.color,
    transform: rotate ? `rotate(${rotate}deg)` : undefined
  };
});
</script>

<script>
export default {
  name: 'SvgIcon'
};
</script>

<style lang="less" scoped>
.svg-icon {
  overflow: hidden;
  vertical-align: -0.15em;
  fill: currentColor;
  box-sizing: content-box;
  outline: none;
}
.border {
  border: 1px solid var(--border-neutral-color-secondary);
  border-radius: 50%;
  padding: 6px;
  cursor: pointer;
  @media (any-hover: hover) {
    &:hover {
      background: var(--color-filled-background-filled-hover);
    }
  }
}
.btn {
  cursor: pointer;
  &:hover {
    color: var(--theme-color);
  }
}
.bg {
  cursor: pointer;
  background: var(--card-background-color);
  border-radius: 50%;
  &:hover {
    color: var(--theme-color);
  }
}
.bgActive {
  background: var(--secondary-background-color);
  color: var(--theme-color);
}
</style>
